<script>
	import { Link } from 'svelte-routing';
</script>

<main>
	<img class="Banner" src="/banner.webp" alt="Banner comunista" />
	<p></p>
	<details id="clique-aqui">
		<summary>Clique aqui!</summary>
		<div style="text-align: center; max-width: 600px; margin: 0 auto;" class="detalhes-conteudo">
			<p>
				Oi, sou o Lucas! 🙂<br>
				Sou natural de Santos, adoro a literatura brasileira – em especial o naturalismo –, Aluisio de Azevedo é o maior escritor de todos! 📚<br>
				Sou Marxista Leninista, filiado ao PCB ☭<br>
				Fui violinista dos meus 9 aos 21 anos 🎻<br>
				Adoro temas voltados para a psicologia e comportamento humano 🧠<br>
				Quero seguir na área de gestão de saúde pública, pelo menos até o momento 🧑‍💼<br>
				Técnico em Farmácia - ETEC 🛠️<br>
				Técnico em Informática - ETEC 🛠️
			</p>
			
		</div>
	</details>
	<p></p>
	<p></p>

	<div class="lista">
		<a href="/pmsus">
			<div class="materia">
				<img src="/pmsus.webp" alt="PMSUS" />
				<h4>PMSUS - Práticas Médicas no SUS</h4>
			</div>
		</a>
		<a href="/ncs">
			<div class="materia">
				<img src="/ncs.webp" alt="NSC" />
				<h4>NSC - Necessidades e Cuidado em Saúde</h4>
			</div>
		</a>
		<a href="/hm">
			<div class="materia">
				<img src="/hm.webp" alt="HM" />
				<h4>HM - Habilidades Médicas e Estações Clínicas</h4>
			</div>
		</a>
	</div>

	<p></p>
	<div class="citacao">
		“O escritor pode ser comparado ao leão: <b>ruge, mas não morde</b>.”
	</div>
	<div class="autor">— Maria Caroline de Jesus</div>
</main>

<style>
	details summary {
		color: blue;
		text-align: center;
		width: 100%;
		margin: 0 auto;
		list-style: none;
		cursor: pointer;
		font-weight: bold;
	}
	a {
		color: inherit;
		text-decoration: none;
	}

	.Banner {
		height: auto;
		width: 100%;
		max-width: 40rem;
		border-radius: 0.5rem;
		display: block;
		margin: 0 auto;
	}

	main {
		padding: 1em;
		margin: 0 auto;
		max-width: 1000px;
	}

	.lista {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;
		justify-content: center;
		text-align: center;
	}

	.lista .materia {
		border: 1px solid;
		border-radius: 0.5em;
		width: 14rem;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		background-color: #fff;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
	}

	.lista .materia img {
		width: 100%;
		height: 20rem;
		aspect-ratio: 3 / 2;
		object-fit: cover;
		border-top-left-radius: 0.5em;
		border-top-right-radius: 0.5em;
	}

	.lista .materia h4 {
		padding: 0.5rem;
		font-size: 0.95rem;
		word-wrap: break-word;
		flex-grow: 1;
	}

	.citacao {
		display: block;
		width: fit-content;
		margin: 1rem auto 0 auto;
		text-align: center;
	}

	.autor {
		display: block;
		width: fit-content;
		margin: 0 auto;
		font-family: Georgia, serif;
		font-size: 0.9rem;
		text-align: center;
	}

	:global(#clique-aqui) {
		display: block;
		width: fit-content;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (max-width: 768px) {
		.lista .materia {
			width: 90%;
		}
	}
</style>
